module.exports = __webpack_public_path__ + "img/yhq.7e05846e.png";